import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

const NO_REFRESH = /\/auth\/(login|register|refresh|logout|forgot-password|reset-password)/;
let refreshing = null;

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const orig = error.config || {};
    if (error.response?.status === 401 && !orig._retry && !NO_REFRESH.test(orig.url || "")) {
      orig._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(orig);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}

export const usd = (n) =>
  `$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fmtDate = (s) =>
  s ? new Date(s).toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";

export const TXN_LABELS = {
  deposit: "Deposit", withdrawal: "Withdrawal", welcome_bonus: "Welcome Bonus", bonus_unlock: "Bonus Unlock",
  daily_return: "Daily Return", principal_return: "Principal Return", investment: "Plan Activation",
  referral_commission: "Commission", admin_adjustment: "Adjustment", withdrawal_refund: "Refund",
};
